<template>
  <section class="title text-center capitalize mt-20 mb-16">
    <h1 class="main-text text-5xl text-black mb-10 dark:text-white">
      generate a powerful password <br />
      to be super secured
    </h1>
    <p class="text-stone-500 text-xl dark:text-slate-400">passwrod generater tool</p>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.main-text {
  font-family: 'Carter One', cursive;
}
</style>
